var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEecsPackages({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_13044)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36386 0.125457C7.21633 0.190584 7.00978 0.338964 6.9049 0.45518C6.80002 0.571307 5.25914 2.98208 3.48061 5.81241C1.40263 9.11932 0.256427 11.0245 0.273505 11.1434L0.30015 11.3284L8.00657 11.3512L15.713 11.3738L15.7661 10.9958C15.816 10.6405 17.0653 0.0968469 17.0653 0.0306534C17.0653 0.0137719 14.9428 0.00159943 12.3487 0.00346529C8.6179 0.00621965 7.57604 0.0317198 7.36386 0.125457ZM22.9666 0.0306534C22.9666 0.0968469 24.2159 10.6405 24.2658 10.9958L24.3189 11.3738L32.0253 11.3512L39.7318 11.3284L39.7584 11.1434C39.7755 11.0245 38.6293 9.11932 36.5513 5.81241C34.7728 2.98208 33.2319 0.571307 33.127 0.455002C32.7176 0.0012441 32.7027 0 27.6637 0C25.0803 0 22.9666 0.0137719 22.9666 0.0306534ZM0.832164 14.3411C0.472451 14.4967 0.0964648 14.9507 0.0319973 15.307C0.00347419 15.4645 -0.00814972 19.5586 0.00606712 24.4051C0.031729 33.1465 0.033428 33.219 0.21628 33.4623C0.317675 33.5973 0.511704 33.7901 0.647524 33.8909L0.894486 34.0741H20.016H39.1374L39.3844 33.8909C39.5202 33.7901 39.7142 33.5973 39.8156 33.4623C39.999 33.2183 40 33.1688 40 24.1673C40 15.1658 39.999 15.1163 39.8156 14.8722C39.7142 14.7372 39.5202 14.5444 39.3844 14.4437C39.1403 14.2625 39.0534 14.2602 31.7227 14.2367L24.3078 14.213V18.2862V22.3593L24.1009 22.5525C23.6937 22.9325 23.7704 22.9749 21.5161 21.1228L20.021 19.8943L18.7443 20.9465C16.3348 22.9324 16.3053 22.9491 15.9185 22.5401C15.7247 22.3351 15.7241 22.3206 15.7241 18.2753V14.216L8.41448 14.2195C2.53944 14.2224 1.05141 14.2462 0.832164 14.3411Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_13044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 34.0741,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEecsPackages);
export default __webpack_public_path__ + "static/media/icon-eecs-packages.5095f2935d331012ad3af777f4e81601.svg";
export { ForwardRef as ReactComponent };